module.exports = __webpack_public_path__ + "img/location.630c2b8c.svg";